export const eyeOptions = [
  { value: 2, text: "Right Eye" },
  { value: 1, text: "Left Eye" },
  { value: 3, text: "OU" },
];
